import { SearchAddressResponseItem } from "../../../../../common/utils/search-address/search-address.response";
import DelegationAddressAddModalAddress from "./types/delegation-address-add-modal-address";
import DelegationAddressAddModalData from "./types/delegation-address-add-modal-data";
import DelegationAddressAddModalOption from "./types/delegation-address-add-modal-option";
import DelegationAddressAddModalSearchSelectOption from "./types/delegation-address-add-modal-search-options";

const createSearchAddressOption = (
  searchAddressResponseItem: SearchAddressResponseItem
): DelegationAddressAddModalOption => {
  return {
    displayName: searchAddressResponseItem.display_name,
    apartmentNumber: "",
    country: searchAddressResponseItem.address.country,
    countryCode: searchAddressResponseItem.address.country_code,
    houseNumber: searchAddressResponseItem.address.house_number ?? null,
    latitude: Number(searchAddressResponseItem.lat),
    longitude: Number(searchAddressResponseItem.lon),
    street: searchAddressResponseItem.address.road ?? null,
    town:
      searchAddressResponseItem.address.city ??
      searchAddressResponseItem.address.town ??
      searchAddressResponseItem.address.village ??
      null,
    zipCode: searchAddressResponseItem.address.postcode ?? null,
  };
};

const createSearchAddressSelectOption = (
  searchAddressResponseItem: SearchAddressResponseItem
): DelegationAddressAddModalSearchSelectOption => {
  const address = createSearchAddressOption(searchAddressResponseItem);

  return {
    label: searchAddressResponseItem.display_name,
    value: address,
  };
};

const createAddressSelectOptions = (
  searchAddressResponseItems: SearchAddressResponseItem[]
): DelegationAddressAddModalSearchSelectOption[] => {
  return searchAddressResponseItems.map(createSearchAddressSelectOption);
};

const createAddress = (
  formData: DelegationAddressAddModalData
): DelegationAddressAddModalAddress => {
  return {
    apartmentNumber: formData.apartmentNumber,
    houseNumber: formData.houseNumber,
    latitude: formData.foundAddress?.value.latitude!,
    longitude: formData.foundAddress?.value.longitude!,
    street: formData.street,
    town: formData.town,
    zipCode: formData.zipCode,
  };
};

const delegationAddressAddModalFactory = {
  createSearchAddressOption,
  createAddressSelectOptions,
  createAddress,
};

export default delegationAddressAddModalFactory;
